module.exports = __webpack_public_path__ + "img/type7.57c8712b.png";